import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Silk from './components/Silk';
import Header from './components/Header';
import BottomNav from './components/BottomNav';
import Home from './pages/Home';
import Courses from './pages/Courses';
import CourseDetail from './pages/CourseDetail';
import Instructors from './pages/Instructors';
import About from './pages/About';
import Profile from './pages/Profile';
import AuthPage from './pages/AuthPage';
import StaffRegister from './pages/StaffRegister';
import EditorUser from './pages/EditorUser';
import BookingPage from './pages/BookingPage';
import Payments from './pages/Payments';
import MastercarRegister from './pages/MastercarRegister';
import Editor from './pages/Editor';
import FileEditor from './pages/FileEditor';
import UnderButtonNav from './components/UnderButtonNav.jsx';
import StaffExtraBooking from './pages/StaffExtraBooking.jsx';
import StaffCalendar from './pages/StaffCalendar';
import ReportsPage from './pages/ReportsPage';
import NotificationsPage from './pages/NotificationsPage';

function App() {
  const { user } = useAuth(); // Доступен внутри AuthProvider

  return (
    <>
      <Header />
      {/* Основной контейнер с отступами для фиксированных Header и BottomNav */}
      <div className="pb-24 lg:pb-0">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/courses" element={<Courses />} />
          <Route path="/courses/:id" element={<CourseDetail />} />
          <Route path="/instructors" element={<Instructors />} />
          <Route path="/about" element={<About />} />
          <Route path="/silk" element={<Silk />} />
          <Route path="/underbuttonnav" element={<UnderButtonNav />} />
          <Route path="/staff-calendar" element={<ProtectedRoute><StaffCalendar /></ProtectedRoute>} />
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/staffextrabooking" element={<ProtectedRoute><StaffExtraBooking /></ProtectedRoute>} />
          <Route path="/notifications" element={<ProtectedRoute><NotificationsPage /></ProtectedRoute>} />
          <Route path="/reports" element={<ProtectedRoute><ReportsPage /></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="/file-editor" element={<ProtectedRoute><FileEditor /></ProtectedRoute>} />
          <Route path="/editor" element={<ProtectedRoute><Editor /></ProtectedRoute>} />
          <Route path="/staff-register" element={<ProtectedRoute><StaffRegister /></ProtectedRoute>} />
          <Route path="/editor-user" element={<ProtectedRoute><EditorUser /></ProtectedRoute>} />
          <Route path="/mastercar-register" element={<ProtectedRoute><MastercarRegister /></ProtectedRoute>} />
          <Route path="/booking" element={<ProtectedRoute><BookingPage /></ProtectedRoute>} />
          <Route path="/payments" element={<ProtectedRoute><Payments /></ProtectedRoute>} />
        </Routes>
      </div>
      {user && <BottomNav />} {/* Только для авторизованных */}
    </>
  );
}

export default function AppWrapper() {
  return (
    <AuthProvider>
      <App />
    </AuthProvider>
  );
}